import { get, post, put, destroy, upload } from 'utils/fetchRequest';

export const getPartnerSchools = async () => {
    try {
        const result = await get('partner-schools');
        return result;
    } catch (err) {
        return { error: err };
    }
};

export const uploadLogo = async (data) => {
    try {
        const result = await upload('files/partner', data);
        return result;
    } catch (err) {
        return { error: err };
    }
};

export const createPartnerSchool = async (data) => {
    try {
        const result = await post('partner-schools', data);
        return result;
    } catch (err) {
        return { error: err };
    }
};

export const updatePartnerSchool = async (id, data) => {
    try {
        const result = await put(`partner-schools/${id}`, data);
        return result;
    } catch (err) {
        return { error: err };
    }
};

export const deletePartnerSchool = async (id) => {
    try {
        const result = await destroy(`partner-schools/${id}`);
        return result;
    } catch (err) {
        return { error: err };
    }
};

export const reorderPartnerSchools = async (items) => {
    try {
        const result = await put('partner-schools/reorder', { items });
        return result;
    } catch (err) {
        return { error: err };
    }
};
